import css from "./Footer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faGithub,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhoneVolume,
  faEnvelopeOpen,
} from "@fortawesome/free-solid-svg-icons";
import { Container, Nav, Row, Col, Image } from "react-bootstrap";
import { Logo, FooterStyle } from "./../../assets/Images";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id={css.footer}>
      <Container className={css.footerCon}>
        <Row id={css.fRow1}>
          {/* Solutions */}
          <Col md={4} className={css.fCol}>
            <h2 className={css.fHeading}>Solutions we deliver</h2>
            <Nav className="flex-column mt-3">
              <Nav.Link href="#services">Web App Development</Nav.Link>
              <Nav.Link href="#services">Mobile App Development</Nav.Link>
              <Nav.Link href="#services">AI &amp; Chatbot Solutions</Nav.Link>
            </Nav>
          </Col>

          {/* Center logo */}
          <Col md={4} className={css.fCol} id={css.fImage}>
            <div className={css.fLogoWrap}>
              <Image
                src={FooterStyle}
                alt="footerImage"
                className={css.fLogo}
              />
              <Image src={Logo} alt="WebZova logo" />

              <h1 style={{ fontSize: "40px", color: "#00d4ff" }}>WebZova</h1>
            </div>
            <p className={css.fTagline}>
              Designing and building digital products that are fast, reliable,
              and built to scale.
            </p>
          </Col>

          {/* Why us */}
          <Col md={4} className={css.fCol} id="fText">
            <h2 className={css.fHeading}>Why clients choose us</h2>
            <p>
              From concept to launch, we partner with businesses to craft clean,
              usable digital experiences—backed by solid engineering.
            </p>
            <div className={css.fSocialRow}>
              <a
                href="https://wa.me/918989558919"
                aria-label="WhatsApp"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a
                href="https://www.linkedin.com/company/webzova"
                aria-label="LinkedIn"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a
                href="https://www.instagram.com/webzova/"
                aria-label="Instagram"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a
                href="https://github.com/"
                aria-label="GitHub"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href="https://x.com/webzova"
                aria-label="GitHub"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
            </div>
          </Col>
        </Row>

        {/* contact strip */}
        <Row className={css.fBottomRow}>
          <Col id={css.fContact}>
            <FontAwesomeIcon icon={faPhoneVolume} />
            <div>
              <p className={css.fContactLabel}>Call anytime</p>
              <p className={css.fContactValue}>+91-8989558919</p>
            </div>
          </Col>
          <Col id={css.fContact}>
            <FontAwesomeIcon icon={faEnvelopeOpen} />
            <div>
              <p className={css.fContactLabel}>Email</p>
              <p className={css.fContactValue}>Shubham@WebZova.Com</p>
            </div>
          </Col>
        </Row>
      </Container>
      {/* {Term  and condition} */}
      <div className={css.terms}>
        <a href="/terms-and-condition">Term And Conditions{"  "}</a>
        {" | "}
        <a href="/privacy-policy"> Privacy Policy.</a>
      </div>
      {/* copyright bar */}
      <div className={css.footerBottom}>
        <span>© {currentYear} WebZova® All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
